import React from 'react';
import { DesktopLayout } from '@/components/layout/DesktopLayout';
import { MobileLayout } from '@/components/layout/MobileLayout';
import { AdvancedFeatureAnnouncementModal } from '@/components/AdvancedFeatureAnnouncementModal';

interface AppShellProps {
  children: React.ReactNode;
}

export const AppShell: React.FC<AppShellProps> = ({ children }) => {
  return (
    <>
      <div className="lg:hidden">
        <MobileLayout>{children}</MobileLayout>
      </div>
      <div className="hidden lg:block">
        <DesktopLayout>{children}</DesktopLayout>
      </div>
      <AdvancedFeatureAnnouncementModal />
    </>
  );
};
